<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="labels" :label="$lang.labels" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <text-field :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="password" type="password" :reveal="true" :clearable="true" icon-left="lock" />
            <password-strength-meter @change="onChange" :rounded="rounded" :labels="labels" :password="password" :class="['my-3']" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">v-model: {{ password }}</code-chunk>
          </card-actions>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">@change: {{ onChangeData }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PagePasswordStrengthMeter',
  mixins: [
    methods
  ],
  data () {
    return {
      password: '',
      labels: false,
      onChangeData: '',
      rounded: false
    }
  },
  methods: {
    onChange ($event) {
      this.log('change', 'password-strength-meter', $event)
      this.onChangeData = $event
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/password-strength-meter.vue